import * as React from "react"

import { GlobalState } from "../../../../../../store"
import { fetchWorkspace } from "../../../../../resources/thunks"
import { useAppDispatch, useAppSelector } from "../../../../../../hooks"
import { workspaceSelector } from "../../../../../resources/adapters"

import Link from "../Link"
import UnavailableLink from "../UnavailableLink"

interface Props {
    attributes: Record<string, string>
    customLabel: string
    label: string
    workspaceId: number
}

export const Workspace = ({
    attributes,
    customLabel,
    label,
    workspaceId,
}: Props): JSX.Element => {
    const dispatch = useAppDispatch()
    const resources = useAppSelector((state: GlobalState) => state.resources)
    const workspace = workspaceSelector.selectById(resources, workspaceId)

    React.useEffect(() => {
        if (!workspace) {
            dispatch(fetchWorkspace(workspaceId))
        }
    }, [])

    if (!workspace) {
        return (
            <UnavailableLink
                attributes={attributes}
                label={label}
                isLoading={true}
            />
        )
    } else if (workspace.doesExist) {
        const href = `workspace/${workspace.id}`

        // we only show the title if there is no custom label
        const linkLabel = customLabel.length > 0 ? customLabel : workspace.title

        return <Link attributes={attributes} label={linkLabel} href={href} />
    }

    return <UnavailableLink attributes={attributes} label={label} />
}

export default Workspace
